/* eslint-disable react-refresh/only-export-components */
import type React from 'react'
import { createContext, useContext, useEffect, useState } from 'react'
import type { ActiveSectionContextType, ActiveSectionProviderProps } from '@/types/contexts'

const ActiveSectionContext = createContext<ActiveSectionContextType | undefined>(undefined)

export const ActiveSectionProvider: React.FC<ActiveSectionProviderProps> = ({ children }) => {
  const getInitialSection = () => {
    const hash = window.location.hash.slice(1)
    return hash || 'z-pile-hr'
  }

  const [activeSection, setActiveSection] = useState<string>(getInitialSection)

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1)
      if (hash) {
        setActiveSection(hash)
      }
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  return (
    <ActiveSectionContext.Provider value={{ activeSection, setActiveSection }}>
      {children}
    </ActiveSectionContext.Provider>
  )
}

export const useActiveSection = () => {
  const context = useContext(ActiveSectionContext)
  if (context === undefined) {
    throw new Error('useActiveSection must be used within an ActiveSectionProvider')
  }
  return context
}
